import React, { useState, useEffect } from 'react';
import { Icon } from '../Icon';
import { useHistory } from 'react-router-dom';
import { useMedia } from '../../../common/hooks/useMedia';
import { useUIContext } from '../../context/UIContext';
import { CustomButton } from '../Button/Button';
import Avatar from '../Avatar/Avatar';
import cx from 'classnames';
import styles from './MobileHeader.module.scss';
import { useTranslation } from 'react-i18next';

function MobileHeader({ showMenuBtn = true, libraryMode, userAvatar, userFirstLetter, openSearchModal = () => { } }) {
  const history = useHistory();

  const { t } = useTranslation();

  const [scrollActive, setScrollActive] = useState(false);

  const smallScreenView = useMedia({ maxWidth: 900 });
  const { mobileSidebar: showMobileSidebar, toggleMobileSidebar } = useUIContext();

  useEffect(() => {
    const checkscroll = () => setScrollActive(window.pageYOffset > 0);
    document.addEventListener('scroll', checkscroll);

    return () => {
      document.removeEventListener('scroll', checkscroll);
    };
  }, []);

  if (!smallScreenView || showMobileSidebar) return null;
  return (
    <div className={styles.stickyWrapper}>
      <div className={cx(styles.outerWrapper, { [styles.mobile]: smallScreenView, [styles.active]: scrollActive })}>
        <div className={styles.topbar}>
          <div className={styles.actionsContainer}>
            {showMenuBtn ? (
              <CustomButton variant={'link'} className={styles.hamburgerMenuBtn} onClick={toggleMobileSidebar} ariaLabel={t('accessibility.menu')}>
                <Icon src="menu" verticalAlign="middle" className={styles.iconContainer} />
              </CustomButton>
            ) : null}
            <CustomButton
              onClick={() => history.push('/eg/home')}
              variant="link"
              className={cx(styles.logoWrapper, { [styles.libraryMode]: libraryMode })}
              ariaLabel={t('accessibility.mobile_logo')}
            >
              <Icon src="mobileLogo" className={styles.iconContainer} />
            </CustomButton>
          </div>
          {libraryMode && (
            <div className={styles.libraryActionsContainer}>
              <CustomButton variant="link" className={styles.libraryModeButton} onClick={openSearchModal} ariaLabel={t('dashboard.search')}>
                <Icon src="search" className={styles.iconContainer} />
              </CustomButton>
              {libraryMode && (
                <div onClick={() => history.push('/eg/settings')}>
                  <Avatar
                    className={styles.miniUserDetail}
                    image={userAvatar || undefined}
                    title={userAvatar ? undefined : userFirstLetter}
                    size="small"
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MobileHeader;
